import styled from "styled-components";
import { Box } from "@mui/material";
import { COLOUR_CONSTANT } from "../../utils/contants";

export const DummyFieldStyled = styled(Box)`
  width: 100%;
  .label {
    margin-bottom: 8px;
  }
  .content {
    height: 36px;
    border: 1px solid ${COLOUR_CONSTANT.theme.purple.medium};
    display: flex;
    align-items: center;
    gap: ${(props) => (props.noGap ? "0px" : "8px")};
    padding: 0 8px;
    border-radius: 4px;
  }
`;
